var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOpenLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 17,
  viewBox: "0 0 16 17"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "nonzero",
  stroke: "currentColor",
  strokeWidth: 0.25
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.786 16.41A2.905 2.905 0 0 1 .875 13.5V5.786a2.905 2.905 0 0 1 2.91-2.911H8.5c.433 0 .768.335.768.768a.756.756 0 0 1-.768.768H3.786c-.767 0-1.375.608-1.375 1.375V13.5c0 .767.608 1.375 1.375 1.375H11.5c.767 0 1.375-.608 1.375-1.375V8.786c0-.434.335-.768.768-.768s.768.334.768.768V13.5a2.905 2.905 0 0 1-2.911 2.91z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.128 1.52v-.003l-.002-.003Zm-1.246 1.988L8.185 9.184a.745.745 0 0 1-1.077.008.746.746 0 0 1-.004-1.08l5.68-5.701h-2.077a.756.756 0 0 1-.768-.768c0-.433.335-.768.768-.768h3.922c.031 0 .057.005.094.014.028.007.03.007.074.014l.024.015c.093 0 .172.049.185.099l.056.029a.7.7 0 0 1 .19.187l.027.032c.02.033.032.06-.005.01.048.049.07.075.077.117.035.024.04.06.032.088.03.058.035.101.035.184v3.93c-.026.414-.364.76-.768.76a.756.756 0 0 1-.768-.768z"
}))));
export default SvgOpenLink;